'use strict';

var BidPriceDirective = function BidPriceDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/bid-price.html'),
    controller: 'BidPriceController',
    scope: {
      entityData: '=',
      mode: '@'
    }
  };
};
BidPriceDirective.$inject = [];
module.exports = BidPriceDirective;